import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import BGImage from '../../Assets/page-title-bg.png'
import "./Hero.css"

const Hero = ({ text, link }) => {
    return (
        <div className="HeroWrapper" image={BGImage}>

            <div className="container">
                <div className="content">
                    <h2>{text}</h2>
                    <ul>
                        <li>
                            <a href={process.env.RAZZLE_APP_BASE_URL}>
                                Home
                            </a>
                        </li>
                        <li>{link}</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}


export default Hero
